import { UserRoles } from '../user-role.type';
import { USER_ROLE_LABELS } from '../../constants/user-role-labels.constants';

export const CREATABLE_USER_ROLES = [
  UserRoles.USER,
  UserRoles.ECO,
  UserRoles.CONTACT,
  UserRoles.ENTREPRISE,
  UserRoles.CONCIERGERIE,
  UserRoles.SUBSCRIBER_BTOB,
  UserRoles.SUBSCRIBER_BTOC,
] as const;

export const CREATABLE_USER_ROLE_LABELS: Record<(typeof CREATABLE_USER_ROLES)[number], string> = {
  [UserRoles.USER]: USER_ROLE_LABELS[UserRoles.USER],
  [UserRoles.ECO]: USER_ROLE_LABELS[UserRoles.ECO],
  [UserRoles.CONTACT]: USER_ROLE_LABELS[UserRoles.CONTACT],
  [UserRoles.ENTREPRISE]: USER_ROLE_LABELS[UserRoles.ENTREPRISE],
  [UserRoles.CONCIERGERIE]: USER_ROLE_LABELS[UserRoles.CONCIERGERIE],
  [UserRoles.SUBSCRIBER_BTOB]: USER_ROLE_LABELS[UserRoles.SUBSCRIBER_BTOB],
  [UserRoles.SUBSCRIBER_BTOC]: USER_ROLE_LABELS[UserRoles.SUBSCRIBER_BTOC],
};

export interface AdminCreateUserAddressDTO {
  title?: string;
  street: string;
  zipCode: string;
  city: string;
  comment?: string;
}

export interface AdminCreateUserRequestDTO {
  role: string;
  firstname: string;
  lastname: string;
  email: string;
  phoneNumber: string;
  password?: string;
  information?: string;
  newsLetter?: boolean;
  groupLabels?: boolean;
  address?: AdminCreateUserAddressDTO;
}
